export default __webpack_public_path__ + "static/media/background_viewEleve_scolarité.84b70dec.jpg";